/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Kutana na watu wapya, zungumza nao, Changamana",
      "idadi ya simu sio sahihi",
      "Get the app",
      "Endelea na Apple",
      "Endelea kupitia Facebook",
      "Endelea kupitia Google",
      "Ingia",
      "Jisajili",
      "Ili kuendelea, tafadhali ingiza vibambo unavyoviona kwenye sehemu ya ingizo.",
      "Endelea",
      "Ingiza vibambo",
      "Ukaguzi wa usalama",
      "Pakia upya",
      "Unda nywila mpya, ambayo utakumbuka kwa urahisi:",
      "Sasisha",
      "Thibitisha nywila",
      "Nywila lazima iwe na angalau [[characters:num]] {{num}}",
      "Nywila",
      "Unda nywila mpya",
      "Badoo - The Blog",
      "Kazi",
      "Gumzo",
      "Majiji",
      "Simamia vidakuzi",
      "Copyright © 2006 – leo. Bumble. Haki zote zimehifadhiwa.",
      "Apple na nembo ya Apple ni chapa za biashara za Apple Inc.{{__EOL__}}Google Play ni chapa ya biashara ya Google LLC.",
      "Pakua",
      "Facebook",
      "Tufuate",
      "Kituo cha Msaada",
      "Instagram",
      "Lugha",
      "LinkedIn",
      "Muhtasari",
      "Badoo ni sehemu ya Bumble Inc.",
      "Sera ya faragha",
      "Kituo cha Usalama",
      "Ramani ya pahali",
      "Taarifa ya Sheria ya Utumwa wa Kisasa",
      "Vigezo na masharti",
      "Twitter",
      "Weka barua pepe yako au namba ya simu nasi tutakutumia maagizo ili kuunda nywila mpya.",
      "Pata nywila mpya",
      "Ingiza barua pepe yako au namba ya simu",
      "Nimesahau Nywila",
      "Modeli zinatumika kwa madhumuni ya kielelezo tu",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Hakuna haja ya kusubiri mwenzi.{{__EOL__}}{{__EOL__}}Nenda kwenye soga motomoto zaidi, na upate mambo mazuri moja kwa moja. Unajua, kidogo mnaweza kupata nafasi ya kujuana.",
      "Uko tayari kwa soga sasa?",
      "Kwa kujisajili, unakubali <a class=\"link\" href=\"{{terms_url}}\">Vigezo na Masharti yetu</a>. Soma ili upate kujua jinsi tunavyotumia data zako katika <a class=\"link\" href=\"{{privacy_url}}\">Sera ya Faragha</a>",
      "Inasaidia kukufanya uwe vile ulivyo, <br />kwa ajili ya mtoko unaohisi vizuri kuuhusu.",
      "Hapa utapata mtoko wa uhakika",
      "Au",
      "Tayari una akaunti?",
      "Jisajili kupitia barua pepe au namba ya simu",
      "Pata unachotaka kutokana na miadi ya mtoko.{{__EOL__}}Hakuna haja ya kuomba msamaha.",
      "Unataka tu kupiga soga? Hiyo ni sawa.{{__EOL__}}Je, uko tayari kutulia? Naipenda hiyo.{{__EOL__}}{{__EOL__}}Na kubadili nia yako, inaruhusiwa kabisa.",
      "Niko hapa kutafuta wa kutoka naye",
      "Niko tayari kwa mahusiano",
      "Niko tayari kwa mazungumzo",
      "Kutana na watu wanaotaka kitu unachotaka.",
      "{{name}}, {{age}}",
      "Usalama wako ndio kipaumbele chetu kikuu.",
      "Kituo chetu cha Usalama ni kitovu cha maarifa, kilicho na usaidizi wote unaohitaji hadi sasa kwa ujasiri.",
      "Tembelea Kituo chetu cha Usalama",
      "Usalama kwanza,<br/>pili, na daima.",
      "Kuanzia mara ya kwanza kabisa, nilidhani ingefanya kazi...",
      "Mwanzoni, sikuwa natafuta mahusiano rasmi...",
      "Ushauri mmoja kwa mtu yeyote kwenye Programu ya Badoo ni kuwa usijiigize...",
      "Hadithi za Mafanikio za Badoo",
      "Angalia hadithi nyingine zaidi za mafanikio",
      "Viwango__CUT__{{num}}",
      "Apple App Store",
      "Tuamini. Tumewaunganisha mamilioni (na mamilioni, na mamilioni) ya watu kuwa pamoja tangu 2006.",
      "{{num}}M+__CUT__Zilizopakuliwa",
      "{{num}}M+",
      "Google Play Store",
      "Tunajua tunachofanya.",
      "Ingia kupitia barua pepe au namba ya simu",
      "Ingiza nywila yako",
      "Umesahau nywila?",
      "Jisajili",
      "Hauna akaunti?",
      "Ingia",
      "Jisajili"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "tabia"
            ],
            "singular": [
                  "tabia"
            ]
      },
      "day": {
            "plural": [
                  "siku"
            ],
            "singular": [
                  "siku"
            ]
      },
      "hour": {
            "plural": [
                  "masaa"
            ],
            "singular": [
                  "saa"
            ]
      },
      "minute": {
            "plural": [
                  "dakika"
            ],
            "singular": [
                  "dakika"
            ]
      },
      "month": {
            "plural": [
                  "miezi"
            ],
            "singular": [
                  "mwezi"
            ]
      },
      "second": {
            "plural": [
                  "sekunde"
            ],
            "singular": [
                  "sekunde"
            ]
      },
      "year": {
            "plural": [
                  "miaka"
            ],
            "singular": [
                  "mwaka"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
